/*
 * Copyright (c) 2026. Pacesetter
 * All Rights Reserved
 */
import * as actions from './actions';
import {
  fetchAdminAPI,
  fetchSystemAPI,
  storeAdminAPI,
  storeSystemAPI,
} from '../../../utils/httpUtil';
import { ADMIN_FAIL_REPORT_CONFIGURATION, ERROR_MESSAGE } from '../../../constants/appConfig';
import {
  DOWNLOAD_ACCOUNTING_REPORTS_URL,
  FETCH_ACCOUNTING_REPORTS_URL,
  MANUAL_TRIGGER_ACCOUNTING_URL,
  FETCH_FAIL_REPORT_SENT_CONFIGURATION_URL,
  UPDATE_FAIL_REPORT_SENT_CONFIGURATION_URL,
  ACCESS_CODE,
  FETCH_FAIL_REPORT_SENT_CONFIGURATION_FOR_ADMIN_URL,
} from '../../../constants/apiConstant';

import { downloadCSV } from '../../../utils/csvUtil';
import { setLocalStorage } from '../../../utils/storageUtil';
import Toast from '../../../components/shared/Toast';

/**
 * Manual trigger for failed transaction reports
 * @param {Object} params - Date range parameters
 */
export const manualTriggerAccounting = (params) => {
  return (dispatch) => {
    dispatch(actions.manualTriggerAccountingRequest());
    return storeAdminAPI(MANUAL_TRIGGER_ACCOUNTING_URL, params)
      .then((response) => {
        if (response.status === 200) {
          dispatch(actions.manualTriggerAccountingSuccess(response?.data?.data));
          Toast('Manual trigger initiated successfully', 'SUCCESS');
          return response;
        }
      })
      .catch((error) => {
        dispatch(
          actions.manualTriggerAccountingFailure(
            error.response ? error.response.data : ERROR_MESSAGE
          )
        );
        Toast(error.response ? error.response.data.message : ERROR_MESSAGE, 'ERROR');
      });
  };
};

/**
 * Fetch failed transaction reports
 * @param {Object} params - Search parameters
 */
export const fetchAccountingReports = (params) => {
  return (dispatch) => {
    dispatch(actions.fetchAccountingReportsRequest());
    return storeAdminAPI(FETCH_ACCOUNTING_REPORTS_URL, params)
      .then((response) => {
        if (response.status === 200) {
          dispatch(actions.fetchAccountingReportsSuccess(response?.data?.data));
          return response;
        }
      })
      .catch((error) => {
        dispatch(
          actions.fetchAccountingReportsFailure(
            error.response ? error.response.data : ERROR_MESSAGE
          )
        );
      });
  };
};

/**
 * Download a specific failed transaction report
 * @param {Object} formData - Form data
 */
export const downloadAccountingReport = (formData) => {
  return (dispatch) => {
    dispatch(actions.downloadAccountingReportRequest());
    return downloadCSV({
      url: DOWNLOAD_ACCOUNTING_REPORTS_URL,
      method: 'post',
      formData: formData,
      fileName: 'failed_transactions_report',
    })
      .then((response) => {
        dispatch(actions.downloadAccountingReportSuccess(response.data));
        return response;
      })
      .catch((error) => {
        dispatch(
          actions.downloadAccountingReportFailure(
            error.response ? error.response.data : ERROR_MESSAGE
          )
        );
      });
  };
};

/**
 * Fetch automation configuration
 * @param {string} accessCode - Company ID
 */
export const fetchFailReportSentConfiguration = (accessCode) => {
  return (dispatch) => {
    dispatch(actions.fetchFailReportSentConfigurationRequest());
    return fetchSystemAPI(FETCH_FAIL_REPORT_SENT_CONFIGURATION_URL.replace(ACCESS_CODE, accessCode))
      .then((response) => {
        if (response.status === 200) {
          dispatch(actions.fetchFailReportSentConfigurationRequestSuccess(response?.data?.data));
          return response;
        }
      })
      .catch((error) => {
        dispatch(
          actions.fetchFailReportSentConfigurationRequestFailure(
            error.response ? error.response.data : ERROR_MESSAGE
          )
        );
      });
  };
};

/**
 * Fetch automation configuration (admin token)
 * @param {string} accessCode - Company access code
 */
export const fetchFailReportSentConfigurationForAdmin = (accessCode) => {
  return (dispatch) => {
    dispatch(actions.fetchFailReportSentConfigurationRequest());
    return fetchAdminAPI(
      FETCH_FAIL_REPORT_SENT_CONFIGURATION_FOR_ADMIN_URL.replace(ACCESS_CODE, accessCode)
    )
      .then((response) => {
        if (response.status === 200) {
          setLocalStorage(ADMIN_FAIL_REPORT_CONFIGURATION, response?.data?.data);
          dispatch(actions.fetchFailReportSentConfigurationRequestSuccess(response?.data?.data));
          return response;
        }
      })
      .catch((error) => {
        dispatch(
          actions.fetchFailReportSentConfigurationRequestFailure(
            error.response ? error.response.data : ERROR_MESSAGE
          )
        );
      });
  };
};

/**
 * Update automation configuration
 * @param {Object} params - Configuration data
 */
export const updateFailReportSentConfiguration = (params) => {
  return (dispatch) => {
    dispatch(actions.updateFailReportSentConfigurationRequest());
    return storeSystemAPI(UPDATE_FAIL_REPORT_SENT_CONFIGURATION_URL, params)
      .then((response) => {
        if (response.status === 200) {
          dispatch(actions.updateFailReportSentConfigurationRequestSuccess(response?.data?.data));
          Toast('Configuration updated successfully', 'SUCCESS');
          return response;
        }
      })
      .catch((error) => {
        dispatch(
          actions.updateFailReportSentConfigurationFailure(
            error.response ? error.response.data : ERROR_MESSAGE
          )
        );
        Toast(error.response ? error.response.data.message : ERROR_MESSAGE, 'ERROR');
      });
  };
};
